import { PropsWithChildren } from 'react'
import Styles from './ColorsPanel.module.scss'

const Root = ({ children }: PropsWithChildren<{}>) => <div className={Styles.section}>{children}</div>

const Header = ({ children }: PropsWithChildren<{}>) => <div className={Styles.sectionHeader}>{children}</div>

export const Section = {
  Root,
  Header,
}
